module.exports = __webpack_public_path__ + "static/media/Logo.858277f5.svg";